import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useIntl } from 'react-intl';
import { priceToString } from '../../utils';

import messages from './messages';
import styles from './CartConfirmationItem.module.scss';

const CartConfirmationItem = ({
  name,
  productUrl = undefined,
  title,
  price,
  discount = undefined,
  imageURL,
  quantity = 1,
}) => {
  const { formatMessage, formatNumber } = useIntl();

  return (
    <div className={styles['product-container']}>
      <div className={styles['product-image']}>
        <img data-testid="cart-confirmation-image" src={imageURL} alt={name} />
      </div>
      <div className={styles['product-data']}>
        <div className={styles['product-name']}>
          <a href={productUrl}>{name}</a>
        </div>
        <div className={styles['product-title']}>{title}</div>
        <div className={styles['product-price-info']}>
          <div
            className={classnames(styles['product-price'], {
              [styles['product-price-line-through']]: discount,
            })}
          >
            {priceToString({
              price: discount
                ? {
                  ...price,
                  centAmount: price.centAmount + discount.centAmount,
                }
                : price,
              formatNumber,
              formatMessage,
            })}
          </div>
          {discount?.centAmount && (
            <div className={styles['product-discounted-price']}>
              {priceToString({
                price,
                formatNumber,
                formatMessage,
              })}
            </div>
          )}
        </div>
        <div className={styles['product-quantity']}>
          {formatMessage(messages.quantity, { quantity })}
        </div>
      </div>
    </div>
  );
};

CartConfirmationItem.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  price: PropTypes.shape({
    type: PropTypes.string,
    currencyCode: PropTypes.string,
    centAmount: PropTypes.number.isRequired,
    fractionDigits: PropTypes.number.isRequired,
  }).isRequired,
  discount: PropTypes.shape({
    type: PropTypes.string,
    currencyCode: PropTypes.string,
    centAmount: PropTypes.number,
    fractionDigits: PropTypes.number,
  }),
  imageURL: PropTypes.string.isRequired,
  productUrl: PropTypes.string,
  quantity: PropTypes.number,
};

export default CartConfirmationItem;
